export default __webpack_public_path__ + "static/media/Victory.e9687931.mp3";